import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useEmpresa } from "app/contexts";

export function ImportacionesTable() {
  const { empresa, deleteImportacion } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Importaciones (opcional)</strong>
            </h5>

            <AddLink to="importaciones/add" title="Agregar importación" />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.importaciones.length ? (
            <Table titles={["#", "Tipo", "Importación", "Opciones"]}>
              {empresa.importaciones.map((importacion, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {importacion.importacion_principal
                      ? "Principal"
                      : "Secundaria"}
                  </td>

                  <td>{importacion.importacion_detalles}</td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`importaciones/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deleteImportacion(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Si importa, por favor, agregue los productos que importa.
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
